var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "PrintOrSaveInvoicesStepComponent",
    {
      staticClass: "invoice-configuration-container",
      attrs: { stepNumber: _vm.stepNumber, title: _vm.texts.title },
    },
    [
      _vm.canSave
        ? _c(
            "div",
            { staticClass: "row-1" },
            [
              _c("LexonSwitchComponent", {
                staticClass: "switch-field",
                attrs: {
                  id: "save",
                  label: _vm.texts.saveLabel,
                  disabled: _vm.disableConfiguration,
                  "hide-details": "",
                },
                on: { input: _vm.configButtons },
                model: {
                  value: _vm.actions.save,
                  callback: function ($$v) {
                    _vm.$set(_vm.actions, "save", $$v)
                  },
                  expression: "actions.save",
                },
              }),
              _c("p", { staticClass: "info-text" }, [
                _vm._v(_vm._s(_vm.texts.saveInfo)),
              ]),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "row-2" },
        [
          _c("LexonSwitchComponent", {
            staticClass: "switch-field",
            attrs: {
              id: "print",
              label: _vm.texts.printLabel,
              disabled: _vm.disableConfiguration,
              "hide-details": "",
            },
            on: { input: _vm.configButtons },
            model: {
              value: _vm.actions.print,
              callback: function ($$v) {
                _vm.$set(_vm.actions, "print", $$v)
              },
              expression: "actions.print",
            },
          }),
          _c("p", { staticClass: "info-text" }, [
            _vm._v(_vm._s(_vm.texts.printInfo)),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }